// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyA0GPloPL6F4nalRS5Zh6MfxxvMWkSgI2s",
    authDomain: "bellabizarre-celeneharder.firebaseapp.com",
    projectId: "bellabizarre-celeneharder",
    storageBucket: "bellabizarre-celeneharder.firebasestorage.app",
    messagingSenderId: "947706261796",
    appId: "1:947706261796:web:ecc908a621a68c4f2643b1",
    measurementId: "G-K90E5JWK87"
};

export const app       = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
export const functions = getFunctions(app);

export default app;
